<template>
    <rkm-overlay>
        <div id="lotacao-container">
            <rkm-col id="lotacao-inner">
                <rkm-form>
                    <h1>Olá, {{ autenticacao.usuario.cidadao.nome }}</h1>

                    <rkm-row class="justify-content-between">
                        <rkm-col cols="auto">
                            <h5 v-if="!model.lotacao">Escolha como você será identificado no sistema</h5>
                            <h5 v-else>Você está identificado como</h5>
                        </rkm-col>
                    </rkm-row>

                    <div class="mb-2" style="overflow-y: scroll; max-height: 508px;">
                        <template v-if="model.lotacao">
                            <rkm-list-group class="mb-2">
                                <rkm-list-group-item
                                    :selected="true"
                                    :disabled="true"
                                >
                                    <rkm-row>
                                        <rkm-col>
                                            <h5 class="mb-0">{{ model.lotacao.infraestrutura.unidade.nomeFantasia }}</h5>
                                            <span class="span"><strong>Local de atendimento:</strong> {{ model.lotacao.infraestrutura.nome }}</span>
                                            <span class="span"><strong>CBO:</strong> {{ model.lotacao.ocupacao.nome }}</span>
                                        </rkm-col>

                                        <rkm-col cols="auto" class="d-flex align-items-center">
                                            <rkm-icon icon="check" />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-list-group-item>
                            </rkm-list-group>

                            <h5>Escolha um setor para continuar</h5>

                            <rkm-list-group class="mb-2">
                                <rkm-list-group-item
                                    v-for="centroCusto in model.lotacao.infraestrutura.centrosCusto"
                                    v-bind:key="centroCusto.id"
                                    :selected="autenticacao.centroCusto && centroCusto.id == autenticacao.centroCusto.id"
                                    @click="handleCentroCusto(centroCusto)"
                                >
                                    <rkm-row>
                                        <rkm-col>
                                            <h5 class="mb-0">{{ centroCusto.setor.nome }}</h5>
                                        </rkm-col>

                                        <rkm-col cols="auto" class="d-flex align-items-center">
                                            <rkm-icon icon="chevron-right" />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-list-group-item>
                            </rkm-list-group>
                        </template>

                        <template v-else>
                            <rkm-list-group class="mb-0" >
                                <rkm-list-group-item
                                    v-for="lotacao in autenticacao.usuario.lotacoes"
                                    v-bind:key="lotacao.id"
                                    :selected="lotacao.selected"
                                    @click="handleLotacao(lotacao)"
                                >
                                    <rkm-row>
                                        <rkm-col>
                                            <h5 class="mb-0">{{ lotacao.infraestrutura.unidade.nomeFantasia }}</h5>
                                            <span class="span"><strong>Local de atendimento:</strong> {{ lotacao.infraestrutura.nome }}</span>
                                            <span class="span"><strong>CBO:</strong> {{ lotacao.ocupacao.nome }}</span>
                                        </rkm-col>

                                        <rkm-col cols="auto" class="d-flex align-items-center">
                                            <rkm-icon icon="chevron-right" />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-list-group-item>
                            </rkm-list-group>
                        </template>
                    </div>

                    <template v-if="autenticacao.usuario.lotacoes.length > 1 && model.lotacao">
                        <rkm-button
                            @click="model.lotacao = null"
                            small
                        >
                            Voltar a identificação
                        </rkm-button>
                    </template>

                    <template v-else>
                        <rkm-button
                            @click.stop="$router.push({ name: 'login', params: { customer: customer.link } })"
                        >
                            Sair do sistema
                        </rkm-button>
                    </template>
                </rkm-form>
            </rkm-col>
        </div>
    </rkm-overlay>
</template>

<script>
import { repository, error } from '@/mixins'
import { mapActions, mapGetters } from "vuex"

export default {
    computed: {
        ...mapGetters({ 'autenticacao': 'getAutenticacao', 'customer': 'getCustomer' })
    },
    mounted() {
        this.repositories.autenticacao = this.getConectaSusRepository('administracao.autenticacao')

        if(this.autenticacao.usuario.lotacoes.length == 1) {
            this.handleLotacao(this.autenticacao.usuario.lotacoes[0])

            if(this.model.lotacao.infraestrutura.centrosCusto.length == 1) {
                this.handleCentroCusto(this.model.lotacao.infraestrutura.centrosCusto[0])
            }
        }
    },
    data: () => ({
        model: {
            lotacao: null
        },
        repositories: {
            autenticacao: null,
        },
    }),
    methods: {
        handleLotacao(lotacao) {
            this.model.lotacao = lotacao
        },
        ...mapActions([
            'setAutenticacao',
            'setCentroCusto',
            'setCliente',
            'setLoading',
            'setLotacao',
            'setMenu',
            'setQuantidadeNotificacoesNaoLidas',
            'setSidebar',
            'unsetLoading',
        ]),
        handleCentroCusto(centroCusto) {

            this.setLoading()

            this.repositories.autenticacao.refresh({
                lotacao_id: this.model.lotacao.id,
                centro_custo_id: centroCusto.id
            })
                .then(({ data }) => {

                    this.setAutenticacao(data)
                    this.setCentroCusto(data.centroCusto)
                    this.setCliente(data.cliente)
                    this.setLotacao(data.lotacao)
                    this.setMenu(data.menu)
                    this.setQuantidadeNotificacoesNaoLidas(data.quantidadeNotificacoesNaoLidas)
                    this.setSidebar(true)

                    this.unsetLoading()

                    this.$router.push({ name: 'dashboard' })
                })
                .catch(error => {

                    this.unsetLoading()
                    this.handleError(error)
                })
        }
    },
    mixins: [ repository, error ]
}
</script>

<style scoped>
button:focus {
    opacity: 0.8;
}

#lotacao-inner {
    max-width: 700px;
}

#lotacao-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

h5 {
    font-size: 17px;
}

h6 {
    font-size: 12px;
    opacity: 0.5;
}

.list-group-item {
    cursor: pointer;
}

.list-group-item span {
    font-size: 13px;
    display: block;
}

.list-group-item:not([disabled]):hover {
    background: var(--primary);
    color: #FFF;
}

.list-group-item[selected] {
    border: 1px solid var(--primary);
    color: var(--primary);
    z-index: 2;
}

.list-group-item[disabled] {
    opacity: 0.7;
    cursor: default;
}
</style>